import { Popover, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch";
import arrowUp from "../../../assets/icons/arrowUp.svg";
import arrowDown from "../../../assets/icons/arrowDown.svg";
import magnifyingGlass from "../../../assets/icons/magnifyingGlass.svg";
import ColumnIcon from "./ColumnIcon";

//wrapper component for NON-LGV, block & rack table column header
const SortableSearchableHeader = ({
  field,
  label,
  index,
  sortConfig,
  searchFilters,
  activeColumnSearch,
  setActiveColumnSearch,
  enableSortSearch,
  requestSort,
  updateFilter,
}) => {
  return (
    <Popover
      trigger="click"
      content={
        <ColumnSearch
          field={field}
          label={label}
          updateFilter={updateFilter}
          searchFilters={searchFilters}
        />
      }
      open={activeColumnSearch === field}
      placement="top"
      onOpenChange={(visible) => {
        if (!visible) setActiveColumnSearch(null);
      }}
    >
      <Dropdown
        key={index}
        menu={{
          items: [
            {
              key: 1,
              label: `Sort by ${
                sortConfig.key === field && sortConfig.direction === "asc"
                  ? "DESC"
                  : "ASC"
              }`,
              extra: (
                <img
                  src={
                    sortConfig.key === field && sortConfig.direction === "asc"
                      ? arrowDown
                      : arrowUp
                  }
                  alt="sort icon"
                />
              ),
              onClick: () => requestSort(field),
            },
            {
              type: "divider",
            },
            {
              key: 2,
              label: "Search",
              extra: <img src={magnifyingGlass} alt="search icon" />,
              onClick: () => {
                setActiveColumnSearch(field);
              },
            },
          ],
        }}
        trigger={["click"]}
        disabled={!enableSortSearch}
      >
        <th className="block-table-header-block-rack">
          <span>{label}</span>
          {enableSortSearch && (
            <ColumnIcon color={searchFilters[field] ? "#4461F2" : "#000000"} />
          )}
          {sortConfig.key && sortConfig.key === field && (
            <img
              src={
                sortConfig.key === field && sortConfig.direction === "asc"
                  ? arrowUp
                  : arrowDown
              }
              alt="sort icon"
            />
          )}
        </th>
      </Dropdown>
    </Popover>
  );
};

export default SortableSearchableHeader;
